// extracted by mini-css-extract-plugin
export var alertIcon = "_tp-0";